import {Fragment, useEffect, useState} from "react";
import InvHistoryIncomingView from "./features/InvHistoryIncomingView";
import InvHistoryIncomingEdit from "./features/InvHistoryIncomingEdit";
import {useReadInventoryChangeDetail} from "./hooks/useReadInventoryChangeDetail";
import {useParams} from "react-router-dom";
import {invHistoryInit} from "./state";
import InvHistoryOutgoingView from "./features/InvHistoryOutgoingView";
import InvHistoryOutgoingEdit from "./features/InvHistoryOutgoingEdit";
import InvHistoryAdjustmentView from "./features/InvHistoryAdjustmentView";
import InvHistoryAdjustmentEdit from "./features/InvHistoryAdjustmentEdit";
import {useUser} from "../../../../util/userContext/UserContext";
import useGoToNavigation from "../../../../util/useGotoNavigation";

export default function InvHistory() {
    const {goToNavigation} = useGoToNavigation();
    const {user} = useUser()
    const {id} = useParams()
    const i = id ? Number(id) : 0;

    const [isEdit, setIsEdit] = useState(false);

    const {data: inventoryChangeDetail} = useReadInventoryChangeDetail({id: i})

    const changeType = inventoryChangeDetail?.changeType

    const btnToggleEdit = () => {
        setIsEdit(!isEdit)
    }

    useEffect(() => {
        if (user) {
            switch (changeType) {
                case "incoming":
                    user.authority.inboundReadYn === "N" && goToNavigation("not_found", {}, false);
                    break;
                case "outgoing":
                    user.authority.outboundReadYn === "N" && goToNavigation("not_found", {}, false);
                    break;
                case "adjustment":
                    user.authority.adjustmentReadYn === "N" && goToNavigation("not_found", {}, false);
                    break;
            }
        }
    }, [changeType]);

    return (
        <>
            {changeType === "incoming" && <>
                {!isEdit
                    ? <InvHistoryIncomingView
                        inventoryChangeDetail={inventoryChangeDetail ?? invHistoryInit}
                        btnToggleEdit={btnToggleEdit}
                    />
                    : <InvHistoryIncomingEdit
                        inventoryChangeDetail={inventoryChangeDetail ?? invHistoryInit}
                        btnToggleEdit={btnToggleEdit}
                    />}
            </>}

            {changeType === "outgoing" && <>
                {!isEdit
                    ? <InvHistoryOutgoingView
                        inventoryChangeDetail={inventoryChangeDetail ?? invHistoryInit}
                        btnToggleEdit={btnToggleEdit}
                    />
                    : <InvHistoryOutgoingEdit
                        inventoryChangeDetail={inventoryChangeDetail ?? invHistoryInit}
                        btnToggleEdit={btnToggleEdit}
                    />}
            </>}

            {changeType === "adjustment" && <>
                {!isEdit
                    ? <InvHistoryAdjustmentView
                        inventoryChangeDetail={inventoryChangeDetail ?? invHistoryInit}
                        btnToggleEdit={btnToggleEdit}
                    />
                    : <InvHistoryAdjustmentEdit
                        inventoryChangeDetail={inventoryChangeDetail ?? invHistoryInit}
                        btnToggleEdit={btnToggleEdit}
                    />}
            </>}
        </>
    );
}